import { render, staticRenderFns } from "./KarriereleiterTabelle.vue?vue&type=template&id=4d61cf0a&scoped=true&"
import script from "./KarriereleiterTabelle.vue?vue&type=script&lang=js&"
export * from "./KarriereleiterTabelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d61cf0a",
  null
  
)

export default component.exports